import React from 'react';

 const SidebarData = [
  {
    title: 'Tableau de bord',
    path: '/DashBoard',
    icon: <img src='/iconeaccueil.svg' alt='image'/>,
    cName: 'nav-text'
  },
  {
    title: 'Évènement',
    path: '/Events',
    icon: <img src='/iconeevent.svg' alt='image'/>,
    cName: 'nav-text'
  },
  {
    title: 'Offres',
    path: '/Offers',
    icon: <img src='/iconeoffres.svg' alt='image'/>,
    cName: 'nav-text'
  },
  {
    title: 'Profil',
    path: '/Profil',
    icon: <img src='/iconeprofil.svg' alt='image'/>,
    cName: 'nav-text'
  },
];

export default SidebarData;